import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { OrgJedDefgini } from './orgjeddefgini';

@Component({
  selector: 'yt-orgjeddefgini-tabs',
  templateUrl: './orgjeddefgini-tabs.component.html'
  , providers: [
    TabsContainerService
  ]
})
export class OrgjeddefginiTabsComponent extends BaseTabsContainer<OrgJedDefgini> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<OrgJedDefgini>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
){
    super(tabsContainerService, activatedRoute, userService);
}

ngOnInit(){
    super.ngOnInit();
}

}
